import { components } from "@/api-schema";

type AddressCityGroup = components["schemas"]["AddressCityGroup"];

/**
 * Returns the address UUIDs of the selected city, or `null` when the city is no longer in the
 * location list or has no addresses. Callers must not query without a filter in the `null` case.
 */
export function resolveCityAddresses(addressGroups: AddressCityGroup[], city: string | null): string[] | null {
  if (!city) return null;

  const addresses = addressGroups.find((group) => group.city === city)?.addresses;

  return addresses?.length ? addresses : null;
}

/** Table props that render the "no vehicles" state without querying, for a city that has no addresses left. */
export const EMPTY_CITY_TABLE_PROPS = { autoFetch: false, data: [] as never[], isLoading: false };
